import http from "../utils/http";
// 파일 업로드
export const postFiles = (file) => {
  return new Promise((resolve, reject) => {
    http
      .post("/files", file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 파일 엑셀 변환
export const postFilesExcel = (file) => {
  return new Promise((resolve, reject) => {
    http
      .post("/files/excel", file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
